import { privateAPI } from '../../config/constants'
import { decrypt } from '../../functions/globalFunctions'

export const getWeatherPrediction = (payload, setState) => {
  return async () => {
    const res = await privateAPI.post(`/weather/weather-prediction`, payload)
    if (res) {
      const result = decrypt(res.data)

      setState(result)
    }
  }
}
